const MIN_INTERVAL_DAYS = 1;
const MAX_INTERVAL_DAYS = 365;
const DEFAULT_INTERVAL_DAYS = 1;
/**
 * Normalizes intervalDays from API/DB (number, numeric string with leading zeros, invalid values).
 * Returns undefined when value is missing, zero, or out of range.
 */
export function normalizeIntervalDays(value) {
    if (value === null || value === undefined || value === '') {
        return undefined;
    }
    let parsed;
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed.length === 0 || !/^\d+$/.test(trimmed)) {
            return undefined;
        }
        parsed = Number.parseInt(trimmed, 10);
    }
    else if (typeof value === 'number') {
        if (!Number.isFinite(value)) {
            return undefined;
        }
        parsed = Math.trunc(value);
    }
    else {
        return undefined;
    }
    if (parsed < MIN_INTERVAL_DAYS || parsed > MAX_INTERVAL_DAYS) {
        return undefined;
    }
    return parsed;
}
/** Safe read path for scheduler — never returns 0 or invalid stored values. */
export function resolveIntervalDays(value, fallback = DEFAULT_INTERVAL_DAYS) {
    return normalizeIntervalDays(value) ?? fallback;
}
//# sourceMappingURL=interval-days.js.map